import { useEffect, useState } from 'react';

const isMatching = (breakpoint: string) => window.matchMedia(breakpoint).matches;

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(isMatching(query));

  useEffect(() => {
    const listener = () => {
      const newMatches = isMatching(query);
      if (matches !== newMatches) setMatches(newMatches);
    };

    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);

  return matches;
};
